export class CrmCalendarioFiltrosDTO {
  inicio: string;
  fim: string;
  idsVisitantes: number[];
}